// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"

const modelClassData = {
  "attributes": {
    "ability_name": {
      "column": {
        "default": null,
        "name": "ability_name",
        "null": false,
        "type": "string"
      },
      "name": "ability_name",
      "selected_by_default": null,
      "translated": false
    },
    "description": {
      "column": null,
      "name": "description",
      "selected_by_default": null,
      "translated": true
    },
    "handled_by_system": {
      "column": {
        "default": false,
        "name": "handled_by_system",
        "null": false,
        "type": "boolean"
      },
      "name": "handled_by_system",
      "selected_by_default": null,
      "translated": false
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": true
    },
    "identifier": {
      "column": {
        "default": null,
        "name": "identifier",
        "null": true,
        "type": "string"
      },
      "name": "identifier",
      "selected_by_default": null,
      "translated": false
    },
    "model_class_name": {
      "column": {
        "default": null,
        "name": "model_class_name",
        "null": true,
        "type": "string"
      },
      "name": "model_class_name",
      "selected_by_default": null,
      "translated": false
    },
    "parameters": {
      "column": {
        "default": null,
        "name": "parameters",
        "null": true,
        "type": "text"
      },
      "name": "parameters",
      "selected_by_default": null,
      "translated": false
    },
    "subject_string": {
      "column": {
        "default": null,
        "name": "subject_string",
        "null": true,
        "type": "string"
      },
      "name": "subject_string",
      "selected_by_default": null,
      "translated": false
    }
  },
  "className": "Ability",
  "collectionKey": "abilities",
  "collectionName": "abilities",
  "i18nKey": "ability",
  "camelizedLower": "ability",
  "name": "Ability",
  "nameDasherized": "ability",
  "pluralName": "abilities",
  "ransackable_associations": [
    {
      "className": "AbilityGroupAbility",
      "collectionName": "ability_group_abilities",
      "foreignKey": "ability_id",
      "name": "ability_group_abilities",
      "macro": "has_many",
      "resource_name": "AbilityGroupAbility",
      "through": null
    },
    {
      "className": "AbilityGroup",
      "collectionName": "ability_groups",
      "foreignKey": "ability_group_id",
      "name": "ability_groups",
      "macro": "has_many",
      "resource_name": "AbilityGroup",
      "through": "ability_group_abilities"
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "RoleAbility",
      "collectionName": "role_abilities",
      "foreignKey": "ability_id",
      "name": "role_abilities",
      "macro": "has_many",
      "resource_name": "RoleAbility",
      "through": null
    },
    {
      "className": "Role",
      "collectionName": "roles",
      "foreignKey": "role_id",
      "name": "roles",
      "macro": "has_many",
      "resource_name": "Role",
      "through": "role_abilities"
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Ability::Translation",
      "collectionName": null,
      "foreignKey": "ability_id",
      "name": "translations",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "ability_name",
      "column": {
        "default": null,
        "name": "ability_name",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "handled_by_system",
      "column": {
        "default": false,
        "name": "handled_by_system",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "identifier",
      "column": {
        "default": null,
        "name": "identifier",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "model_class_name",
      "column": {
        "default": null,
        "name": "model_class_name",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "parameters",
      "column": {
        "default": null,
        "name": "parameters",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "subject_string",
      "column": {
        "default": null,
        "name": "subject_string",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_has_ability_group_ability_asc"
    },
    {
      "name": "sort_by_has_ability_group_ability_desc"
    },
    {
      "name": "sort_by_has_role_ability_asc"
    },
    {
      "name": "sort_by_has_role_ability_desc"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [],
  "paramKey": "ability",
  "primaryKey": "id"
}

/** Frontend model for Ability. */
export default class Ability extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  abilityName() {
    return this.readAttributeUnderscore("ability_name")
  }

  /** @returns {boolean} */
  hasAbilityName() {
    const value = this.abilityName()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  description() {
    return this.readAttributeUnderscore("description")
  }

  /** @returns {boolean} */
  hasDescription() {
    const value = this.description()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  handledBySystem() {
    return this.readAttributeUnderscore("handled_by_system")
  }

  /** @returns {boolean} */
  hasHandledBySystem() {
    const value = this.handledBySystem()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  identifier() {
    return this.readAttributeUnderscore("identifier")
  }

  /** @returns {boolean} */
  hasIdentifier() {
    const value = this.identifier()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  modelClassName() {
    return this.readAttributeUnderscore("model_class_name")
  }

  /** @returns {boolean} */
  hasModelClassName() {
    const value = this.modelClassName()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  parameters() {
    return this.readAttributeUnderscore("parameters")
  }

  /** @returns {boolean} */
  hasParameters() {
    const value = this.parameters()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  subjectString() {
    return this.readAttributeUnderscore("subject_string")
  }

  /** @returns {boolean} */
  hasSubjectString() {
    const value = this.subjectString()

    return this._isPresent(value)
  }
}
